export const COURSE_CATALOGUE = [
  {
    category: "Cytech Bicycle Mechanic Training",
    blurb: "Industry-recognised Cytech certification pathway, from home workshop skills to senior technician.",
    courses: [
      { slug: "professional-bicycle-mechanic", name: "Professional Bicycle Mechanic", note: "Cytech Theory 1, Technical 1 & 2 combined", duration: "80 hours · 10 days over 2–4 weeks", length: "Multi-Week", certification: "Cytech Certification", tuition: "$2,300 CAD + gst", dates: "October intakes — see course calendar", description: "A comprehensive course combining the first three steps of the Cytech training process — the foundation for any mechanic looking to work in the industry and confidently take on any repair." },
      { slug: "cytech-certificate-challenge", name: "Cytech 1 & 2 Certificate Challenge", note: "For experienced mechanics · assessment-based", duration: "3 days", length: "Short Course", certification: "Cytech Certification", tuition: "Contact admissions", dates: "Sat 3 – Mon 5, October", description: "Experienced mechanics can challenge the Cytech Theory 1 and Technical 1 & 2 certifications through a condensed assessment format." },
      { slug: "advanced-bicycle-mechanic", name: "Advanced Bicycle Mechanic", note: "Cytech Technical 3", duration: "40 hours · 5 days", length: "40–80 Hours", certification: "Cytech Certification", tuition: "Contact admissions", dates: "Mon 26 – Fri 30, October", description: "The highest level of Cytech training — advanced diagnostics, full suspension servicing, and complete wheel building for a senior technician career." },
      { slug: "mechanic-development-program", name: "Mechanic Development Program (MDP)", note: "Extended professional pathway", duration: "Multi-week program", length: "Multi-Week", certification: "Cytech Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "An extended pathway combining Cytech levels with supervised workshop practice to take you from enthusiast to employed professional." },
      { slug: "bike-mechanic-suspension", name: "Suspension Service", note: "Fork & shock, 50-hr to full service", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Master suspension theory, lower leg service, damper and air spring work, and full rebuilds across major brands." },
      { slug: "advanced-wheel-building", name: "Advanced Wheel Building", note: "Complete wheel design & construction", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "From spoke calculation to final truing — design and build complete wheels to professional tolerances." },
      { slug: "electronic-gear-systems", name: "Electronic Gear Systems", note: "Di2, AXS & modern drivetrains", duration: "1–2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Install, pair, firmware-update and troubleshoot modern electronic shifting systems from Shimano, SRAM and others." },
      { slug: "hydraulic-brakes", name: "Hydraulic Brakes", note: "Bleeding, service & diagnostics", duration: "1–2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Confidently bleed, service and diagnose hydraulic disc brake systems across all major manufacturers." },
      { slug: "technical-e-bike", name: "Technical E-Bike", note: "Motors, batteries & e-systems", duration: "2–3 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "E-bike drivetrains, motor systems, battery safety and diagnostics — essential skills for the modern workshop." },
      { slug: "rental-bike-technician", name: "Rental Bike Technician", note: "Fleet maintenance & turnover", duration: "40 hours · 5 days", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Fast, safe fleet turnaround — inspection routines, high-volume maintenance and damage assessment for rental operations." },
      { slug: "home-mechanic", name: "Home Mechanic", note: "Evening course · your own fleet", duration: "4 evenings", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Set up a home workshop and learn to maintain, tune and repair your own bikes with confidence." },
      { slug: "trail-mechanic", name: "Trail Mechanic", note: "On-trail repairs & trailside fixes", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Handle trailside mechanicals — broken chains, bent derailleurs, tubeless failures — without ending your ride." },
    ],
  },
  {
    category: "Guide Training",
    blurb: "Professional guiding credentials across ski, rock, alpine and bike disciplines.",
    courses: [
      { slug: "ski-guide", name: "Ski Guide Level 1, 2 & 3", note: "Progressive certification pathway", duration: "Multi-week per level", length: "Multi-Week", certification: "Guide Certification", tuition: "Contact admissions", dates: "Winter intakes", description: "A progressive pathway to professional ski guiding — terrain management, avalanche awareness, and client care in the backcountry." },
      { slug: "rock-guide", name: "Rock Guide Level 1, 2 & 3", note: "Progressive certification pathway", duration: "Multi-week per level", length: "Multi-Week", certification: "Guide Certification", tuition: "Contact admissions", dates: "Summer intakes", description: "From top-rope management to multi-pitch guiding — build the technical and instructional skills of a professional rock guide." },
      { slug: "alpine-guide", name: "Alpine Guide Level 1, 2 & 3", note: "Progressive certification pathway", duration: "Multi-week per level", length: "Multi-Week", certification: "Guide Certification", tuition: "Contact admissions", dates: "Summer intakes", description: "Glacier travel, anchor building, alpine rock and summit objectives — the complete alpine guiding skill set." },
      { slug: "bike-instructor-level-1", name: "Bike Instructor Level 1", note: "PMBI-aligned instruction", duration: "3–4 days", length: "Short Course", certification: "Guide Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "Learn to teach mountain biking professionally — lesson structure, skill progression, and group safety." },
      { slug: "bike-guide-co-op", name: "Bike Guide Co-op", note: "Paid work placement", duration: "Seasonal placement", length: "Placement", certification: "Industry Placement", tuition: "Contact admissions", dates: "Summer season", description: "Put your training to work with a paid co-op placement guiding rides for a partner operator." },
      { slug: "guiding-clients", name: "Guiding Clients", note: "Client care & group management", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "The soft skills of guiding — reading groups, managing risk conversations, and delivering memorable client experiences." },
      { slug: "experiential-leadership-guiding", name: "Experiential Leadership & Guiding", note: "Lead groups with confidence", duration: "40 hours", length: "40–80 Hours", certification: "Guide Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "Develop as an outdoor leader — decision-making frameworks, group dynamics, and experiential education techniques." },
      { slug: "mountain-biking-skills", name: "Mountain Biking Skills", note: "Rider development & technique", duration: "2–3 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Progress your own riding — body position, braking, cornering and terrain reading with professional coaches." },
      { slug: "sustainable-trail-building", name: "Sustainable Trail Building", note: "Design, build & maintain trails", duration: "40 hours", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Learn sustainable trail design, drainage, construction and maintenance from experienced trail builders." },
    ],
  },
  {
    category: "Winter & Backcountry Skills",
    blurb: "Travel safely and confidently in mountain terrain, summer and winter.",
    courses: [
      { slug: "snow-orientation", name: "Snow Orientation", note: "Winter travel fundamentals", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Winter intakes", description: "Essential winter mountain skills — equipment, layering, snowpack basics, and safe travel in winter terrain." },
      { slug: "backcountry-skiing-snowboarding", name: "Backcountry Skiing & Snowboarding", note: "Touring technique & safety", duration: "2–3 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Winter intakes", description: "Transition from resort to backcountry — touring technique, transitions, route finding and companion safety." },
      { slug: "snowmobile-guide", name: "Snowmobile Guide", note: "Sled access & guiding", duration: "Multi-day", length: "40–80 Hours", certification: "Guide Certification", tuition: "Contact admissions", dates: "Winter intakes", description: "Operate and guide with snowmobiles — machine handling, mountain riding, rescue and client management." },
      { slug: "backpacking", name: "Backpacking", note: "Multi-day trip skills", duration: "Multi-day", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Summer intakes", description: "Plan and lead multi-day trips — navigation, camp craft, food planning and Leave No Trace practices." },
      { slug: "alpine-climbing", name: "Alpine Climbing", note: "Glacier & alpine rock", duration: "Multi-day", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Summer intakes", description: "Climb in alpine terrain — glacier crossings, anchor building, belaying and rock movement skills." },
      { slug: "outdoor-survival-skills", name: "Outdoor Survival Skills", note: "Shelter, fire & navigation", duration: "2 days", length: "Short Course", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "When things go wrong — shelter building, fire craft, signalling and navigation fundamentals for the backcountry." },
    ],
  },
  {
    category: "Wilderness Medicine",
    blurb: "Certified first aid training for outdoor professionals.",
    courses: [
      { slug: "wilderness-advanced-first-aid", name: "Wilderness Advanced First Aid", note: "40-hr certification", duration: "40 hours", length: "40–80 Hours", certification: "First Aid Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "Comprehensive wilderness medical training — patient assessment, trauma care, and extended-care scenarios far from help." },
      { slug: "wilderness-first-responder", name: "Wilderness First Responder", note: "80-hr professional standard", duration: "80 hours", length: "Multi-Week", certification: "First Aid Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "The industry standard for outdoor professionals — 80 hours of scenario-based wilderness medicine and rescue decision-making." },
      { slug: "wfr-recertification", name: "WFR Recertification / Bridge", note: "Keep your ticket current", duration: "2–3 days", length: "Short Course", certification: "First Aid Certification", tuition: "Contact admissions", dates: "Rolling start dates", description: "Renew your Wilderness First Responder certification or bridge from another recognised provider." },
    ],
  },
  {
    category: "Marketing & Media Courses",
    blurb: "Individual 45-hour courses from the Marketing & Media Manager Diploma — each earns its own certificate.",
    courses: [
      { slug: "photography", name: "Photography", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "April & November intakes", description: "Master your camera — exposure, composition, and shooting in mountain light while building a professional portfolio." },
      { slug: "photo-editing", name: "Photo Editing", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "June & Nov/Dec intakes", description: "Professional post-production workflows — Lightroom and Photoshop techniques to make your images stand out." },
      { slug: "videography", name: "Videography", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "January & July intakes", description: "Shoot cinematic video — camera movement, audio, lighting and storytelling for brands and outdoor content." },
      { slug: "video-editing", name: "Video Editing", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "February & September intakes", description: "Cut footage into stories — editing workflows, colour grading, sound design and delivery for every platform." },
      { slug: "digital-marketing-social-media", name: "Principles of Digital Marketing & Social Media", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "February intake", description: "Strategy, channels, analytics and content — how modern digital marketing actually works, with Hootsuite certification." },
      { slug: "event-planning", name: "Event Planning", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "August intake", description: "Plan and execute real events — budgeting, logistics, promotion and on-the-day management." },
      { slug: "marketing-strategy", name: "Marketing Strategy", note: "45 hrs", duration: "45 hours", length: "40–80 Hours", certification: "Diploma Credit", tuition: "Contact admissions", dates: "Rolling start dates", description: "Identify markets, set goals and build strategies — the thinking layer behind every successful campaign." },
      { slug: "business-plan-development", name: "Business Plan Development", note: "Entrepreneurship fundamentals", duration: "45 hours", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Turn an idea into a viable business plan — market research, financials, and pitching your concept." },
      { slug: "marketing-co-op", name: "Marketing Co-op Work Experience", note: "200-hr placement", duration: "200 hours", length: "Placement", certification: "Industry Placement", tuition: "Contact admissions", dates: "Flexible placement", description: "Apply your skills in a real workplace — past placements include arts councils, film festivals and major brands." },
    ],
  },
  {
    category: "Mountain Sport Technician Courses",
    blurb: "The craft of ski & snowboard equipment — build, tune and fit.",
    courses: [
      { slug: "ski-snowboard-production", name: "Ski & Snowboard Production", note: "Build your own board or skis", duration: "40 hours · 5 days", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Mon 16 – Fri 20, November", description: "From raw materials to finished product — design and press your own handmade ski or snowboard, then ride it." },
      { slug: "ski-snowboard-tuning", name: "Ski & Snowboard Tuning", note: "Edges, base & wax science", duration: "40 hours · 5 days", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Rolling start dates", description: "Base grinding, edge work and wax science — keep equipment performing at its best, for yourself or a shop." },
      { slug: "boot-fitting", name: "Ski / Snowboard Bootfitting", note: "Fit, shells & liners", duration: "40 hours · 5 days", length: "40–80 Hours", certification: "Course Certificate", tuition: "Contact admissions", dates: "Mon 9 – Fri 13, November", description: "The art and science of boot fitting — foot analysis, shell work, liners and custom footbeds." },
      { slug: "mst-coop", name: "MST Co-op Work Experience", note: "Industry placement", duration: "Placement-based", length: "Placement", certification: "Industry Placement", tuition: "Contact admissions", dates: "Flexible placement", description: "Gain real industry hours in rental, retail and tuning workshops through a supervised co-op placement." },
    ],
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1534146789009-76ed5060ec70?q=80&w=1600&auto=format&fit=crop",
  workshop: "https://images.unsplash.com/photo-1760310936486-4dd450aab2a8?q=80&w=1600&auto=format&fit=crop",
  forest: "https://images.unsplash.com/photo-1633707167682-9068729bc84c?q=80&w=1600&auto=format&fit=crop",
  lake: "https://images.unsplash.com/photo-1555204057-c9828fa945e7?q=80&w=1600&auto=format&fit=crop",
  bikeClose: "https://images.unsplash.com/photo-1675798227643-da319f8ee8f7?q=80&w=1600&auto=format&fit=crop",
  gear: "https://images.unsplash.com/photo-1562615193-cbeef074a501?q=80&w=1600&auto=format&fit=crop",
  garage: "https://images.unsplash.com/photo-1676531443468-0e2b5a57e48f?q=80&w=1600&auto=format&fit=crop",
  clapboard: "https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=1600&auto=format&fit=crop",
  snowboardHold: "https://images.unsplash.com/photo-1518608774889-b04d2abe7702?q=80&w=1600&auto=format&fit=crop",
  skiTrick: "https://images.unsplash.com/photo-1551524559-8af4e6624178?q=80&w=1600&auto=format&fit=crop",
  pine: "https://images.unsplash.com/photo-1552273577-cbd60e50b171?q=80&w=1600&auto=format&fit=crop",
  hikers: "https://images.unsplash.com/photo-1600813828722-cde42dc764d9?q=80&w=1600&auto=format&fit=crop",
  snowLake: "https://images.unsplash.com/photo-1637478846759-aea91679069f?q=80&w=1600&auto=format&fit=crop",
  snowboarder: "https://images.unsplash.com/photo-1478700485868-972b69dc3fc4?q=80&w=1600&auto=format&fit=crop",
};

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1673870861521-626b40f9657e?q=80&w=1200&auto=format&fit=crop", caption: "In the workshop" },
  { src: "https://images.unsplash.com/photo-1491002052546-bf38f186af56?q=80&w=1200&auto=format&fit=crop", caption: "Built by hand" },
  { src: "https://images.unsplash.com/photo-1535369643553-a33e0d1ac81d?q=80&w=1200&auto=format&fit=crop", caption: "Trail days" },
  { src: "https://images.unsplash.com/photo-1625690303837-654c9666d2d0?q=80&w=1200&auto=format&fit=crop", caption: "On location" },
  { src: "https://images.unsplash.com/photo-1548777123-e216912df7d8?q=80&w=1200&auto=format&fit=crop", caption: "The backyard" },
  { src: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=1200&auto=format&fit=crop", caption: "The edit suite" },
  { src: "https://images.unsplash.com/photo-1498146831523-fbe41acdc5ad?q=80&w=1200&auto=format&fit=crop", caption: "Winter intake" },
  { src: "https://images.unsplash.com/photo-1511994298241-608e28f14fde?q=80&w=1200&auto=format&fit=crop", caption: "Ride what you build" },
];

export const PROGRAMS = [
  {
    id: "professional-bicycle-mechanic",
    index: "01",
    title: "Professional Bicycle Mechanic",
    category: "Technical Certification",
    credential: "Cytech Theory 1 · Technical 1 & 2",
    duration: "80 hours · 10 days over 2–4 weeks",
    classSize: "4–6 students",
    tuition: "$2,300 CAD + gst",
    image: IMAGES.bikeClose,
    summary:
      "A comprehensive course combining the first three steps of the Cytech training process — the foundation for any mechanic looking to work in the industry and confidently take on any repair.",
    learn: [
      "Industry overview, workshop practices, workplace safety",
      "Tires, tubes and tubeless technology",
      "Derailleur gear systems and drivetrain components",
      "Bearings, hubs and headsets",
      "Disc brakes and hydraulic bleeding",
      "Wheel truing, spoke replacement and intro to wheel building",
      "Suspension theory and 50-hour maintenance",
    ],
    outcomes: [
      "Graduate with Cytech Theory 1, Technical 1 and Technical 2 certifications",
      "Gain the experience needed for professional work in bicycle shops",
      "Eligible to book Open Shop Days to continue developing skills",
    ],
    whoFor: "Aspiring mechanics, bike shop employees looking to upskill, and enthusiasts who want a deeper technical understanding.",
  },
  {
    id: "advanced-bicycle-mechanic",
    index: "02",
    title: "Advanced Bicycle Mechanic",
    category: "Technical Certification",
    credential: "Cytech Technical 3",
    duration: "5 days · 40 hours",
    classSize: "4–6 students",
    tuition: "Contact admissions",
    image: IMAGES.gear,
    summary:
      "The highest level of Cytech training. Master advanced diagnostics, suspension servicing, and complete wheel building for a senior technician career.",
    learn: [
      "Advanced hydraulic brake systems",
      "Full suspension fork and shock service",
      "Complete wheel building",
      "Electronic shifting systems",
      "Advanced frame and bearing diagnostics",
    ],
    outcomes: [
      "Cytech Technical 3 certification — the industry benchmark for senior mechanics",
      "Qualification for lead technician and service manager roles",
    ],
    whoFor: "Graduates of the Professional course and working mechanics ready to lead a workshop.",
  },
  {
    id: "recreational-bicycle-mechanic",
    index: "03",
    title: "Recreational Bicycle Mechanic",
    category: "Skills Course",
    credential: "Home & Trail Mechanic Certificates",
    duration: "Evenings & weekends",
    classSize: "6–8 students",
    tuition: "Contact admissions",
    image: IMAGES.garage,
    summary:
      "Hands-on evening courses for riders who want to maintain and repair their own bikes — at home in the workshop and out on the trail.",
    learn: [
      "Essential home workshop setup and tool selection",
      "Drivetrain cleaning, tuning and replacement",
      "Brake adjustment and pad replacement",
      "On-trail emergency repairs",
      "Pre-ride safety inspection routines",
    ],
    outcomes: [
      "Confidently maintain your entire personal fleet",
      "Handle trailside mechanicals without ending your ride",
    ],
    whoFor: "Riders of any level who want independence from the repair shop queue.",
  },
  {
    id: "marketing-media-manager",
    index: "04",
    title: "Marketing & Media Manager Diploma",
    category: "Diploma Program",
    credential: "Diploma · PTIRU Accredited · Hootsuite Certification",
    duration: "470 hours within 12 months · 21.5 credits",
    classSize: "Small cohort",
    tuition: "Contact admissions",
    image: IMAGES.clapboard,
    summary:
      "Seven creative, industry-based courses plus a co-op work placement. Build a photography and videography portfolio, plan real marketing strategies, and master social media and event planning.",
    learn: [
      "Photography and photo editing",
      "Videography and video editing",
      "Principles of digital marketing and social media",
      "Event planning and execution",
      "Marketing strategy and market segmentation",
      "200-hour co-op work experience",
    ],
    outcomes: [
      "Marketing & Media Manager Diploma",
      "Careers: Marketing Coordinator, Social Media Specialist, Events Coordinator, Junior Videographer/Photographer",
    ],
    whoFor: "Creative individuals looking to expand media skills or learn the fundamentals of marketing and how to implement them.",
  },
  {
    id: "mountain-sport-technician",
    index: "05",
    title: "Mountain Sport Technician",
    category: "Diploma Program",
    credential: "Diploma · PTIRU Accredited",
    duration: "Multi-course program",
    classSize: "4–6 students",
    tuition: "Contact admissions",
    image: IMAGES.snowboardHold,
    summary:
      "Ski production, snowboard construction and bootfitting — learn to build and fit mountain equipment from raw materials to finished product.",
    learn: [
      "Ski and snowboard design and press construction",
      "Base grinding, edging and waxing science",
      "Ski and snowboard bootfitting",
      "Binding mounting and safety standards",
      "Workshop operations and customer service",
    ],
    outcomes: [
      "Produce your own handmade ski or snowboard",
      "Industry-ready technician skills for rental, retail and tuning shops",
    ],
    whoFor: "Hands-on learners passionate about mountain equipment and the craft behind it.",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Small Classrooms",
    text: "Four to six students per class. Every question gets heard, every hand gets guided, and no one learns from the back row.",
  },
  {
    number: "02",
    title: "Hands-On Learning",
    text: "Theory matters — but mastery comes from doing. Our students learn by building, repairing, and solving real problems with real tools.",
  },
  {
    number: "03",
    title: "Critical Thinking",
    text: "We don't teach memorisation. We teach diagnosis, judgement, and the confidence to reason through problems you've never seen before.",
  },
  {
    number: "04",
    title: "Recognised Certification",
    text: "Formally accredited by the Private Training Institutions Regulatory Unit (PTIRU) of British Columbia, with industry-recognised credentials including Cytech training.",
  },
];

export const STATS = [
  { value: 255, label: "Professional Mechanics Trained" },
  { value: 178, label: "Skis & Snowboards Produced" },
  { value: 7, label: "Certification Pathways" },
  { value: 3000, label: "Hours of Instruction Delivered" },
];

export const TESTIMONIALS = [
  {
    quote: "Through the college I had the opportunity to build my own snowboard — handmade, of course. The highlight of the process is the moment your new board comes out of the press.",
    name: "Kevin Cajochen",
    country: "Switzerland",
    program: "Ski / Snowboard Production",
  },
  {
    quote: "School is flexible — I am really enjoying the marketing program while I work. New experiences, new stories. This college was the door for all of this to happen.",
    name: "Hector Garcia",
    country: "Mexico",
    program: "Marketing & Media Manager",
  },
  {
    quote: "The course schedule was flexible and suited my lifestyle. I found all of the teachers friendly, very skilled and approachable.",
    name: "Martina Gejdosova",
    country: "Slovakia",
    program: "Diploma Student",
  },
  {
    quote: "The perfect fit for anyone with the desire to work or learn more about the industry. The programs allow students to get knowledge in very specific areas but also learn more global culture.",
    name: "Remy Metailler",
    country: "France",
    program: "Professional Athlete",
  },
  {
    quote: "A fun, educational, and balanced experience that set me up to achieve my goals. I was fully prepared to step into a guiding role — the transition from school to work was seamless.",
    name: "Dani Huff",
    country: "USA",
    program: "Bike Program Graduate",
  },
  {
    quote: "This school is amazing — you make friends, have fun, and develop in your actual job. I improved at my favourite hobby thanks to extraordinary teachers.",
    name: "Daniel Villa",
    country: "Mexico",
    program: "Photography Student",
  },
  {
    quote: "An awesome videography course which enriched my skills. I highly recommend the program to anyone who would like to broaden their skills in digital marketing and media.",
    name: "Solon Kougkoulos",
    country: "Greece",
    program: "Marketing & Media Manager",
  },
  {
    quote: "The college gave me warm support to reach my goal while staying in Canada. I earned a scholarship for a film production program afterwards.",
    name: "Eric Frankhauser",
    country: "Switzerland",
    program: "Film & Media Student",
  },
];

export const NEWS = [
  {
    id: 1,
    category: "News",
    title: "From Powder to Pedals: Study, Play, and Behind the Scenes",
    author: "Kate Kozak",
    image: IMAGES.skiTrick,
    excerpt: "Important dates, events, and course information from campus.",
  },
  {
    id: 2,
    category: "Blog",
    title: "A Swiss Student's Journey: From the Alps to a Dream Life",
    author: "College Contributor",
    image: IMAGES.pine,
    excerpt: "Many years ago, I worked for my parents who own a small shop back home…",
  },
  {
    id: 3,
    category: "News",
    title: "Gap Year Opens New Doors for Students from Mexico",
    author: "Kate Kozak",
    image: IMAGES.hikers,
    excerpt: "Why a gap year in Canada changes everything for international students.",
  },
  {
    id: 4,
    category: "Blog",
    title: "Why More Mexican Students Are Choosing a Gap Year in Canada",
    author: "College Contributor",
    image: IMAGES.snowLake,
    excerpt: "Flexible programs, small classes, and a life outdoors.",
  },
  {
    id: 5,
    category: "News",
    title: "From the Trails to the Classrooms Around the World",
    author: "Kate Kozak",
    image: IMAGES.forest,
    excerpt: "Alumni stories from workshops and studios across the globe.",
  },
  {
    id: 6,
    category: "Blog",
    title: "Trails, Tools & Powder Days: My Journey as a Student",
    author: "College Contributor",
    image: IMAGES.snowboarder,
    excerpt: "What a year of hands-on study actually looks like, day to day.",
  },
];

export const CALENDAR = [
  { course: "Professional Bike Mechanic — Cytech 1&2 Certificate Challenge", month: "October", dates: "Sat 3 – Mon 5", times: "9:00AM – 5:00PM" },
  { course: "MST — Professional Mechanic 1/2", month: "October", dates: "Wed 7 – Thu 8 · Tue 13 – Fri 16 · Mon 19 – Thu 22", times: "9:00AM – 5:00PM" },
  { course: "MST — Advanced Mechanic 3", month: "October", dates: "Mon 26 – Fri 30", times: "9:00AM – 5:00PM" },
  { course: "MST — Ski/Snowboard Bootfitting", month: "November", dates: "Mon 9 – Fri 13", times: "9:00AM – 5:00PM" },
  { course: "MST — Ski Production", month: "November", dates: "Mon 16 – Fri 20", times: "9:00AM – 5:00PM" },
];

export const POLICIES = [
  { name: "Academic Integration Policy", file: "/policies/academic-integration-policy.pdf" },
  { name: "Artificial Intelligence (AI) Use Policy", file: "/policies/ai-use-policy.pdf" },
  { name: "Attendance Policy", file: "/policies/attendance-policy.pdf" },
  { name: "Critical Incident & Crisis Management Policy", file: "/policies/critical-incident-crisis-management-policy.pdf" },
  { name: "Dismissal Policy", file: "/policies/dismissal-policy.pdf" },
  { name: "Dispute Resolution Policy", file: "/policies/dispute-resolution-policy.pdf" },
  { name: "Grades Appeal Policy", file: "/policies/grades-appeal-policy.pdf" },
  { name: "Prior Learning Assessment (PAL) Policy", file: "/policies/pal-policy.pdf" },
  { name: "Privacy Policy", file: "/policies/privacy-policy.pdf" },
  { name: "Referencing & Citation Policy (APA 7th Edition)", file: "/policies/referencing-citation-policy.pdf" },
  { name: "Respectful & Fair Treatment of Students Policy", file: "/policies/respectful-fair-treatment-policy.pdf" },
  { name: "Sexual Harassment & Violence Policy", file: "/policies/sexual-harassment-violence-policy.pdf" },
  { name: "Tuition Refund Policy", file: "/policies/tuition-refund-policy.pdf" },
  { name: "Work Experience Policy", file: "/policies/work-experience-policy.pdf" },
];

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/victoriacareercollege/" },
  { name: "Facebook", url: "https://www.facebook.com/victoriacareercollege/" },
];

export const CONTACT = {
  phone: "604 359 9400",
  email: "info@vccbc.com",
  address: "12725 80 Ave, Surrey, BC V3W 3A6",
  hours: "Classes run most days throughout summer and fall. To visit, we request you book an appointment to ensure faculty is available.",
};
